var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );
dependencies["front/utils/sites.jinja"] = require( "front/utils/sites.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/TopNav/TopNavDesktop.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/TopNav/TopNavDesktop.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n";
env.getTemplate("front/utils/sites.jinja", false, "assets/app/front/components/TopNav/TopNavDesktop.jinja", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
if(Object.prototype.hasOwnProperty.call(t_4, "SITE_AVAILABILITY")) {
var t_7 = t_4.SITE_AVAILABILITY;
} else {
cb(new Error("cannot import 'SITE_AVAILABILITY'")); return;
}
context.setVariable("SITE_AVAILABILITY", t_7);
output += "\n\n";
var macro_t_8 = runtime.makeMacro(
[], 
["request", "data", "page"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("request", Object.prototype.hasOwnProperty.call(kwargs, "request") ? kwargs["request"] : {});frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});frame.set("page", Object.prototype.hasOwnProperty.call(kwargs, "page") ? kwargs["page"] : "");var t_9 = "";t_9 += "\n    <a href=\"";
t_9 += runtime.suppressValue((lineno = 4, colno = 17, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:index"])), env.opts.autoescape);
t_9 += "\" class=\"TopNavDesktop-logo\">\n        ";
t_9 += runtime.suppressValue((lineno = 5, colno = 30, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"svgSprite"), "macros[\"svgSprite\"]", context, ["logo-header","0 0 160 80",runtime.makeKeywordArgs({"caller": (function (){var macro_t_10 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_11 = "";;
frame = frame.pop();
return new runtime.SafeString(t_11);
});
return macro_t_10;})()})])), env.opts.autoescape);
t_9 += "\n    </a>\n\n    <div class=\"TopNavDesktop-searchWrapper\">\n        <div class=\"TopNavDesktop-searchBtn\">\n            <div class=\"TopNavDesktop-searchIcon\">\n                ";
t_9 += runtime.suppressValue((lineno = 11, colno = 38, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"svgSprite"), "macros[\"svgSprite\"]", context, ["search-icon","0 0 24 24",runtime.makeKeywordArgs({"caller": (function (){var macro_t_12 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_13 = "";;
frame = frame.pop();
return new runtime.SafeString(t_13);
});
return macro_t_12;})()})])), env.opts.autoescape);
t_9 += "\n            </div>\n            <input class=\"TopNavDesktop-searchInput\" type=\"text\" spellcheck=\"false\" autocapitalize=\"off\" autocomplete=\"off\" autocorrect=\"off\" name=\"search\"  value=\"\" placeholder=\"SEARCH\">\n            <div class=\"TopNavDesktop-search-tip\">Hit Enter to Search</div>\n        </div>\n    </div>\n\n    <div class=\"TopNavDesktop-sidebar\">\n        <div class=\"TopNavDesktop-sidebarTable\">\n            <div class=\"TopNavDesktop-sidebarCell\">\n                <ul class=\"TopNavDesktop-sidebarList\">\n                    <li>\n                        <a href=\"";
t_9 += runtime.suppressValue((lineno = 23, colno = 37, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:join"])), env.opts.autoescape);
t_9 += "\" class=\"";
if((runtime.contextOrFrameLookup(context, frame, "page") == "join")) {
t_9 += "TopNavDesktop-sidebarListItem--active";
;
}
t_9 += "\">Join</a>\n                        <ul class=\"TopNavDesktop-sidebarListNested ";
if(((lineno = 24, colno = 87, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "page")),"startswith"), "page[\"startswith\"]", context, ["join"])))) {
t_9 += "TopNavDesktop-sidebarListNested--opened";
;
}
t_9 += "\">\n                            <li><a href=\"";
t_9 += runtime.suppressValue((lineno = 25, colno = 45, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:join_portfolio_review"])), env.opts.autoescape);
t_9 += "\" class=\"";
if((runtime.contextOrFrameLookup(context, frame, "page") == "join_portfolio_review")) {
t_9 += "TopNavDesktop-sidebarListItem--active";
;
}
t_9 += "\">Portfolio Review</a></li>\n                        </ul>\n                    </li>\n                    <li>\n                        <a href=\"";
t_9 += runtime.suppressValue((lineno = 29, colno = 37, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:members"])), env.opts.autoescape);
t_9 += "\" class=\"";
if((runtime.contextOrFrameLookup(context, frame, "page") == "members")) {
t_9 += "TopNavDesktop-sidebarListItem--active";
;
}
t_9 += "\">Directory</a>\n                        <ul class=\"TopNavDesktop-sidebarListNested ";
if((runtime.contextOrFrameLookup(context, frame, "page") == "members")) {
t_9 += "TopNavDesktop-sidebarListNested--opened";
;
}
t_9 += "\">\n                            <li><a href=\"";
t_9 += runtime.suppressValue((lineno = 31, colno = 52, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "domain_url"), "domain_url", context, [runtime.contextOrFrameLookup(context, frame, "SITE_AVAILABILITY"),"index"])), env.opts.autoescape);
t_9 += "\" target=\"_blank\">AVAILABILITY LIST</a></li>\n                        </ul>\n                    </li>\n                    <li><a href=\"";
t_9 += runtime.suppressValue((lineno = 34, colno = 37, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:events"])), env.opts.autoescape);
t_9 += "\" class=\"";
if((runtime.contextOrFrameLookup(context, frame, "page") == "events")) {
t_9 += "TopNavDesktop-sidebarListItem--active";
;
}
t_9 += "\">Events</a></li>\n                    <li>\n                        <a href=\"";
t_9 += runtime.suppressValue((lineno = 36, colno = 37, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:awards"])), env.opts.autoescape);
t_9 += "\" class=\"";
if((runtime.contextOrFrameLookup(context, frame, "page") == "awards")) {
t_9 += "TopNavDesktop-sidebarListItem--active";
;
}
t_9 += "\">Awards</a>\n                        <ul class=\"TopNavDesktop-sidebarListNested ";
if(((lineno = 37, colno = 87, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "page")),"startswith"), "page[\"startswith\"]", context, ["awards"])))) {
t_9 += "TopNavDesktop-sidebarListNested--opened";
;
}
t_9 += "\">\n                            <li><a href=\"";
t_9 += runtime.suppressValue((lineno = 38, colno = 45, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:awards_adg"])), env.opts.autoescape);
t_9 += "\" class=\"";
if((runtime.contextOrFrameLookup(context, frame, "page") == "awards_adg")) {
t_9 += "TopNavDesktop-sidebarListItem--active";
;
}
t_9 += "\">ADG Awards</a></li>\n                        </ul>\n                    </li>\n                    <li>\n                        <a href=\"";
t_9 += runtime.suppressValue((lineno = 42, colno = 37, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:guild"])), env.opts.autoescape);
t_9 += "\" class=\"";
if((runtime.contextOrFrameLookup(context, frame, "page") == "guild")) {
t_9 += "TopNavDesktop-sidebarListItem--active";
;
}
t_9 += "\">The Guild</a>\n                        <ul class=\"TopNavDesktop-sidebarListNested ";
if(((lineno = 43, colno = 87, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "page")),"startswith"), "page[\"startswith\"]", context, ["guild"])))) {
t_9 += "TopNavDesktop-sidebarListNested--opened";
;
}
t_9 += "\">\n                            <li><a href=\"";
t_9 += runtime.suppressValue((lineno = 44, colno = 45, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:guild_board"])), env.opts.autoescape);
t_9 += "\" class=\"";
if((runtime.contextOrFrameLookup(context, frame, "page") == "guild_board")) {
t_9 += "TopNavDesktop-sidebarListItem--active";
;
}
t_9 += "\">Board, Council &&nbsp;Committees</a></li>\n                            <li><a href=\"";
t_9 += runtime.suppressValue((lineno = 45, colno = 45, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:guild_staff"])), env.opts.autoescape);
t_9 += "\" class=\"";
if((runtime.contextOrFrameLookup(context, frame, "page") == "guild_staff")) {
t_9 += "TopNavDesktop-sidebarListItem--active";
;
}
t_9 += "\">Staff & FAQ</a></li>\n                            <li><a href=\"";
t_9 += runtime.suppressValue((lineno = 46, colno = 45, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:guild_production_design_initiative"])), env.opts.autoescape);
t_9 += "\" class=\"";
if((runtime.contextOrFrameLookup(context, frame, "page") == "guild_production_design_initiative")) {
t_9 += "TopNavDesktop-sidebarListItem--active";
;
}
t_9 += "\">Production Design Initiative</a></li>\n                        </ul>\n                    </li>\n                    <li><div class=\"TopNavDesktop-sidebarSeparator\"></div></li>\n\n                    ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "request")),"user")),"member")) {
t_9 += "\n                        <li><a href=\"";
t_9 += runtime.suppressValue((lineno = 52, colno = 41, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:myadg"])), env.opts.autoescape);
t_9 += "\" class=\"TopNavDesktop-sidebarListItem--myadg ";
if((runtime.contextOrFrameLookup(context, frame, "page") == "myadg")) {
t_9 += "TopNavDesktop-sidebarListItem--active";
;
}
t_9 += "\">";
t_9 += runtime.suppressValue((lineno = 52, colno = 193, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"svgSprite"), "macros[\"svgSprite\"]", context, ["menu-myadg","0 0 22 27",runtime.makeKeywordArgs({"caller": (function (){var macro_t_14 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_15 = "";;
frame = frame.pop();
return new runtime.SafeString(t_15);
});
return macro_t_14;})()})])), env.opts.autoescape);
t_9 += " My ADG</a></li>\n                        <li><a href=\"";
t_9 += runtime.suppressValue((lineno = 53, colno = 41, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:rates"])), env.opts.autoescape);
t_9 += "\" class=\"TopNavDesktop-sidebarListItem--rates ";
if((runtime.contextOrFrameLookup(context, frame, "page") == "rates")) {
t_9 += "TopNavDesktop-sidebarListItem--active";
;
}
t_9 += "\">";
t_9 += runtime.suppressValue((lineno = 53, colno = 193, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"svgSprite"), "macros[\"svgSprite\"]", context, ["menu-rates","0 0 28 25",runtime.makeKeywordArgs({"caller": (function (){var macro_t_16 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_17 = "";;
frame = frame.pop();
return new runtime.SafeString(t_17);
});
return macro_t_16;})()})])), env.opts.autoescape);
t_9 += " Rates & Contracts</a></li>\n                        <li><a href=\"";
t_9 += runtime.suppressValue((lineno = 54, colno = 41, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:benefits"])), env.opts.autoescape);
t_9 += "\" class=\"TopNavDesktop-sidebarListItem--benefits ";
if((runtime.contextOrFrameLookup(context, frame, "page") == "benefits")) {
t_9 += "TopNavDesktop-sidebarListItem--active";
;
}
t_9 += "\">";
t_9 += runtime.suppressValue((lineno = 54, colno = 202, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"svgSprite"), "macros[\"svgSprite\"]", context, ["menu-benefits","0 0 26 26",runtime.makeKeywordArgs({"caller": (function (){var macro_t_18 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_19 = "";;
frame = frame.pop();
return new runtime.SafeString(t_19);
});
return macro_t_18;})()})])), env.opts.autoescape);
t_9 += " Benefits</a></li>\n                        <li><a href=\"";
t_9 += runtime.suppressValue((lineno = 55, colno = 41, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:faq"])), env.opts.autoescape);
t_9 += "\" class=\"TopNavDesktop-sidebarListItem--faq ";
if((runtime.contextOrFrameLookup(context, frame, "page") == "faq")) {
t_9 += "TopNavDesktop-sidebarListItem--active";
;
}
t_9 += "\">";
t_9 += runtime.suppressValue((lineno = 55, colno = 187, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"svgSprite"), "macros[\"svgSprite\"]", context, ["menu-faq","0 0 22 22",runtime.makeKeywordArgs({"caller": (function (){var macro_t_20 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_21 = "";;
frame = frame.pop();
return new runtime.SafeString(t_21);
});
return macro_t_20;})()})])), env.opts.autoescape);
t_9 += " Faq</a></li>\n                        <li><a class=\"TopNavDesktop-sidebarListItem--logout\">";
t_9 += runtime.suppressValue((lineno = 56, colno = 99, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"svgSprite"), "macros[\"svgSprite\"]", context, ["menu-logout","0 0 22 22",runtime.makeKeywordArgs({"caller": (function (){var macro_t_22 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_23 = "";;
frame = frame.pop();
return new runtime.SafeString(t_23);
});
return macro_t_22;})()})])), env.opts.autoescape);
t_9 += " LogOut</a></li>\n                    ";
;
}
else {
t_9 += "\n                        <li><a href=\"";
t_9 += runtime.suppressValue((lineno = 58, colno = 41, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:login-popup"])), env.opts.autoescape);
t_9 += "\" class=\"TopNavDesktop-sidebarListItem--login u-Route\">";
t_9 += runtime.suppressValue((lineno = 58, colno = 140, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"svgSprite"), "macros[\"svgSprite\"]", context, ["menu-myadg","0 0 22 27",runtime.makeKeywordArgs({"caller": (function (){var macro_t_24 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_25 = "";;
frame = frame.pop();
return new runtime.SafeString(t_25);
});
return macro_t_24;})()})])), env.opts.autoescape);
t_9 += " Member Log in</a></li>\n                    ";
;
}
t_9 += "\n                </ul>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"TopNavDesktop-sidebarLogo\">\n        ";
t_9 += runtime.suppressValue((lineno = 66, colno = 30, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"svgSprite"), "macros[\"svgSprite\"]", context, ["logo","0 0 160 150",runtime.makeKeywordArgs({"caller": (function (){var macro_t_26 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_27 = "";;
frame = frame.pop();
return new runtime.SafeString(t_27);
});
return macro_t_26;})()})])), env.opts.autoescape);
t_9 += "\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_9);
});
context.addExport("TopNavDesktop");
context.setVariable("TopNavDesktop", macro_t_8);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/TopNav/TopNavDesktop.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/TopNav/TopNavDesktop.jinja
// module id = 131
// module chunks = 0